module.exports = __webpack_public_path__ + "static/media/21.a3691e3e.jpg";